<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/requisitions"
          ></back-button>
          Add Requisition
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`procurement-management/requisitions`"
              >Requisition</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="requisition-tab"
                  data-bs-toggle="tab"
                  href="#requisition"
                  role="tab"
                  aria-controls="requisition"
                  aria-selected="true"
                  >Requisition</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="requisitionDetial-tab"
                  data-bs-toggle="tab"
                  href="#requisitionDetial"
                  role="tab"
                  aria-controls="requisitionDetial"
                  aria-selected="false"
                  >Requisition Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Requisition Sectiion -->
              <div
                class="tab-pane fade show active"
                id="requisition"
                role="tabpanel"
                aria-labelledby="requisition-tab"
              >
                <h4>Requisition</h4>
                <hr />
                <requisition-form :form="form"></requisition-form>
              </div>
              <!-- For Requsition Details -->
              <div
                class="tab-pane fade"
                id="requisitionDetial"
                role="tabpanel"
                aria-labelledby="requisitionDetial-tab"
              >
                <h4>Requisition Details</h4>
                <hr />
                <requisition-detail-form :form="form"></requisition-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import RequisitionForm from "../requisitions/requisition-form.vue";
import RequisitionDetailForm from "../requisitions/requisition-detail-form.vue";
export default {
  components: { RequisitionForm, RequisitionDetailForm },
  name: "RequisitionCreate",
  data() {
    return {
      form: {
        vessel_id: "",
        requisition_details: [
          {
            spare_part_id: "",
          },
        ],
      },
      vessels: [],
      spareParts: [
        { id: 1, name: "Spare 1" },
        { id: 2, name: "Spare 2" },
      ],
      isLoading: false,
    };
  },
  // mounted() {
  //   this.getMasters();
  // },
  methods: {
    // async getMasters() {
    //   let masters = await axios.get("requisitions/masters");
    //   masters = masters.data;
    //   masters.vessels.forEach((vessel) => {
    //     this.vessels.push({
    //       id: vessel.id,
    //       name: vessel.name,
    //     });
    //   });
    // },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        this.crew = await axios.post("/requisitions", this.form);
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/procurement-management/requisitions");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    // deleteRequisitionDetail(speed) {
    //   this.form.requisition_details = this.form.requisition_details.filter(
    //     (ar) => ar != speed
    //   );
    // },
    // addEmptyRequisitionDetails() {
    //   this.form.requisition_details.push({
    //     company_id: this.company.id,
    //     spare_part_id: "",
    //     qty: "",
    //     comments: "",
    //   });
    // },
    // async delete_requisition_detail_data(id) {
    //   let check = confirm("Are you sure you want to delete the data");
    //   if (check) {
    //     try {
    //       this.isLoading = true;
    //       await axios.post(`delete?id=${id}&table_name=requisition_details`);
    //       this.isLoading = false;
    //       this.getData();
    //     } catch (e) {
    //       this.isLoading = false;
    //     }
    //   }
    // },
  },
};
</script>
